import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["selected", "name", "setFieldValue", "label", "disabled", "dropDownOptions", "handleSearchChange"];
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@mch-group/uikit-components';
import CMultiSelect from './common/CMultiSelect';

var UserGroupSelector = function UserGroupSelector(props) {
  var selected = props.selected,
      name = props.name,
      setFieldValue = props.setFieldValue,
      label = props.label,
      disabled = props.disabled,
      dropDownOptions = props.dropDownOptions,
      handleSearchChange = props.handleSearchChange,
      rest = _objectWithoutProperties(props, _excluded);

  var getSelectedGroups = function getSelectedGroups() {
    if (selected) {
      var foundElement = dropDownOptions.filter(function (element) {
        return selected.includes(element.key);
      });
      return foundElement;
    }

    return [];
  };

  var handleSelection = function handleSelection(selectedList) {
    if (selectedList) {
      var list = selectedList.map(function (element) {
        return element.value;
      });
      setFieldValue(name, list);
      return;
    }

    setFieldValue(name, []);
  };

  return /*#__PURE__*/React.createElement(CMultiSelect, _extends({
    options: dropDownOptions,
    label: label,
    name: name,
    disable: disabled,
    showArrow: true // eslint-disable-next-line no-unused-vars
    ,
    onSelect: function onSelect(selectedList, selectedItem) {
      handleSelection(selectedList);
    } // eslint-disable-next-line no-unused-vars
    ,
    onRemove: function onRemove(selectedList, removedItem) {
      handleSelection(selectedList);
    },
    onSearch: function onSearch(searchBy) {
      typeof handleSearchChange === 'function' && handleSearchChange(searchBy);
    },
    selectedValues: getSelectedGroups(),
    customArrow: /*#__PURE__*/React.createElement(Icon, {
      name: "caret-down",
      color: "#000",
      size: 20,
      style: {
        marginBottom: 20
      }
    })
  }, rest));
};

UserGroupSelector.propTypes = {
  selected: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string,
  setFieldValue: PropTypes.func,
  disabled: PropTypes.bool,
  dropDownOptions: PropTypes.array,
  handleSearchChange: PropTypes.func,
  displayValue: PropTypes.string
};
export default UserGroupSelector;